import apiClient from './apiClient';
import { hasConsent } from '../utils/cookieConsent';

/** Coalesce parallel page-view calls (e.g. React Strict Mode). */
const pageViewInflight = new Map();

const analyticsService = {
  /** PHP: home_page on site index (SPA has no server-rendered home). */
  recordPageView: async (eventType) => {
    if (!hasConsent('analytics')) {
      return { success: false, skipped: true, reason: 'analytics_consent_required' };
    }

    const key = String(eventType);
    if (pageViewInflight.has(key)) {
      return pageViewInflight.get(key);
    }

    const request = apiClient
      .post('/analytics/page-view', { event_type: eventType })
      .finally(() => {
        setTimeout(() => pageViewInflight.delete(key), 300);
      });

    pageViewInflight.set(key, request);
    return request;
  },
};

export default analyticsService;
